$(document).ready(function () {

	let socials = $('#SocialMediaLinks');
	let leftBlock = $('.left-block--lower');
	if (window.innerWidth >= 767) {
		leftBlock.before(socials);
	}
});
